import axios from 'axios';

class Newsletter {
  constructor(options) {

    var defaults = {
      messages: {
        success: 'Completed',
        failure: 'Failed'
      }
    };
    this.params = Object.assign({}, defaults, options || {});
    this.container = document.querySelector(this.params.selector);
    this.form = this.container.querySelector('form');
    this.input = this.container.querySelector('.newsletter-email');
    this.endpoint = this.form.getAttribute('action');
    this.log = this.container.querySelector('.newsletter-module-response');

    if (this.form) {
      this.addEvents();
    }
  }

  addEvents() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.log.textContent = '';
      this.subscribe();
    });

    this.input.addEventListener('focus', function () {
      this.parentNode.classList.add('focusin');
    }, true);
    this.input.addEventListener('blur', function () {
      if (!this.value) {
        this.parentNode.classList.remove('focusin');
      }
    }, true);
  }

  subscribe() {
    var data = this.getFormData();
    axios.post(this.endpoint, data)
      .then((response) => {
        if (response.data.success) {
          this.log.textContent = this.params.messages.success;
        } else {
          this.log.textContent = this.params.messages.failure;
        }
      })
      .catch((error) => {
        this.log.textContent = this.params.messages.failure;
      });
  }

  getFormData() {
    var data = new FormData();
    this.form.querySelectorAll('input').forEach((element) => {
      data.append(element.name, element.value);
    });
    return data;
  }


}

export {
  Newsletter as
    default
};
